module.exports = __webpack_public_path__ + "static/JT_img-ca6dc97c6ea382012946fb4fcdaf83a2.png";